<template>
    <BasePage ref="page" class="column" :style="`height: calc(100vh - ${bottomPadding}); overflow: hidden; margin-left: -15px`">
        <q-tab-panels v-model="tab" animated class="col no-margin no-padding base-page-content">
            <q-tab-panel class="no-margin no-padding" v-for="(item, index) in params" :key="index" :name="item.value" style="overflow: hidden; background-color: #FDFBF5">
                <Page style="overflow: hidden; margin-top: -10px; padding-top: 0; padding-left: 0" :params="{ uuid: item.value }" :tabbed="true" />
            </q-tab-panel>
        </q-tab-panels>
        <!--<q-space />-->
        <q-tabs
            class="col-auto"
            v-model="tab"
            dense
            narrow-indicator
        >
            <q-tab v-for="(item, index) in params" :key="index" :name="item.value" :label="item.label" :icon="item.icon" />
        </q-tabs>
    </BasePage>
</template>

<script>
import BasePage from 'pages/BasePage';

export default {
    name: 'PageTabs',
    components: { BasePage },
    props: {
        params: {
            type: Object,
            default: undefined,
        },
    },
    data () {
        return {
            tab: undefined,
            bottomPadding: '80px',
        };
    },
    mounted () {
        if (this.params && this.params.length > 0) {
            this.tab = this.params[0].value;
        }
        if (this.$q.platform.is.mobile) {
            this.$refs.page.$el.style.marginTop = '0';
            this.bottomPadding = '100px';
        } else {
            this.$refs.page.$el.style.marginTop = '-30px';
            this.bottomPadding = '80px';
        }
    },
};
</script>

<style scoped lang="scss">
</style>
